export class RequestQuote {
    public CartOrderNo: KnockoutObservable<string>;
    public Comment: KnockoutObservable<string>;
    public DisplayMessages: KnockoutObservable<string>;

    constructor() {
        let self: RequestQuote = this;

        let CartKey = "RequestNewKey";

        if (localStorage.getItem("CartSessionKey"))
            CartKey = localStorage.getItem("CartSessionKey").toString().trim();

        self.CartOrderNo = ko.observable(CartKey);
        self.Comment = ko.observable(null).extend({ required: true, minLength: 1, maxLength: 5000 });
        self.DisplayMessages = ko.observable(null);
    }

}